const ListAccreditationKey = "1"
const ListEditAccreditationKey = "2"
const InspectionProcessKey = "3"
const CreateNewCustomerKey = "4"
const AccreditationNotificationKey = "5"
const AccreditationStatisticalKey = "6"
const ListReportStaistic = '7'
const AccreditationSettingKey = "8"

export {
  ListAccreditationKey,
  ListEditAccreditationKey,
  InspectionProcessKey,
  CreateNewCustomerKey,
  AccreditationNotificationKey,
  AccreditationStatisticalKey,
  ListReportStaistic,
  AccreditationSettingKey
}

export const TYPE_VEHICLE_REPORT = [
  {
    value : 1,
    label : "Ô tô từ 9 ghế đổ xuống, CThg"
  },
  {
    value : 2,
    label : "Ô tô khách 10 - 24 ghế"
  },
  {
    value : 3,
    label :  "Ô tô khách 25 - 40 ghế"
  },
  {
    value : 4,
    label : "Ô tô khách trên 40 ghế"
  },
  {
    value : 5,
    label : "Ô tô tải đến 2T"
  },
  {
    value : 6,
    label : "Ô tô tải trên 2T đến 7T"
  },
  {
    value : 7,
    label : "Ô tô tải trên 7T đến 20T, CD"
  },
  {
    value : 8,
    label : "Ô tô tải trên 20T, CD"
  },
  {
    value : 9,
    label : "PT vận tải nhỏ"
  },
  {
    value : 10,
    label : "Ro mooc, sơ mi rooc moc"
  },
  {
    value : 11,
    label : "xe lam, xích lô máy 3 bánh"
  },
  {
    value : "",
    label : "Tổng cộng"
  },
]

